import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/SolutionsCronHostingPage.head';
import { SolutionsCronHostingPage } from '@pages/SolutionsCronHostingPage';

export const Route = createFileRoute('/solutions/cron-hosting')({
  component: SolutionsCronHostingPage,
  head: () => head,
});
